import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ListItem\ReorderListItemsController::__invoke
* @see app/Http/Controllers/ListItem/ReorderListItemsController.php
* @route '/api/list-item/reorder'
*/
const ReorderListItemsController = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderListItemsController.url(options),
    method: 'put',
})

ReorderListItemsController.definition = {
    methods: ["put"],
    url: '/api/list-item/reorder',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ListItem\ReorderListItemsController::__invoke
* @see app/Http/Controllers/ListItem/ReorderListItemsController.php
* @route '/api/list-item/reorder'
*/
ReorderListItemsController.url = (options?: RouteQueryOptions) => {
    return ReorderListItemsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListItem\ReorderListItemsController::__invoke
* @see app/Http/Controllers/ListItem/ReorderListItemsController.php
* @route '/api/list-item/reorder'
*/
ReorderListItemsController.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderListItemsController.url(options),
    method: 'put',
})

export default ReorderListItemsController